import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api/whatsapp';
const cfg = { withCredentials: true };

export const waApi = {
  status: () => axios.get(`${API}/status`, cfg).then(r => r.data),
  access: () => axios.get(`${API}/access`, cfg).then(r => r.data),
  saveAccess: (userId, body) => axios.put(`${API}/access/${userId}`, body, cfg).then(r => r.data),
  simulate: (userId, text, buttonId = '') => axios.post(`${API}/simulate`, { user_id: userId, text, button_id: buttonId }, cfg).then(r => r.data),
  sendTest: (userId, text) => axios.post(`${API}/send-test`, { user_id: userId, text }, cfg).then(r => r.data),
  messages: (userId, limit = 60) => axios.get(`${API}/messages`, { ...cfg, params: { user_id: userId || undefined, limit } }).then(r => r.data),
  preview: (kind, userId) => axios.get(`${API}/reports/preview`, { ...cfg, params: { kind, user_id: userId || undefined } }).then(r => r.data),
  sendNow: (kind, userId) => axios.post(`${API}/reports/send-now`, { kind, user_id: userId || undefined }, cfg).then(r => r.data),
  syncTemplates: () => axios.post(`${API}/templates/sync`, {}, cfg).then(r => r.data),
  routeHere: () => axios.post(`${API}/route-here`, {}, cfg).then(r => r.data),
  settings: () => axios.get(`${API}/settings`, cfg).then(r => r.data),
  saveSettings: (body) => axios.put(`${API}/settings`, body, cfg).then(r => r.data),
};

export const errMsg = (e) => e?.response?.data?.detail || e?.message || 'Something went wrong';
